module.exports = __webpack_public_path__ + "img/fw-signet.ea683b2a.png";